import ProjectPage from "../Projects/ProjectsPage";

export default function Work() {
  return (
    <>
      <ProjectPage />
    </>
  );
}
